/**
 * Shared kbd-hint footer for both InlineChipCard (editor) and the
 * focused-state SuggestionStrip card. Presentational only — visibility
 * of each hint is governed by props so callers can hide the ones that
 * don't apply (e.g. strip mode has no Tab-navigation between cards yet).
 */

interface ChipKbdHintsProps {
  showSpeak?: boolean;
  showAccept?: boolean;
  showRemove?: boolean;
  showDismiss?: boolean;
  showNext?: boolean;
}

export function ChipKbdHints({
  showSpeak = true,
  showAccept = false,
  showRemove = false,
  showDismiss = false,
  showNext = false,
}: ChipKbdHintsProps) {
  return (
    <div className="rj-inline-card__hints">
      {showSpeak && (
        <span>
          <kbd>`</kbd> speak
        </span>
      )}
      {showAccept && (
        <span>
          <kbd>⏎</kbd> accept
        </span>
      )}
      {showDismiss && (
        <span>
          <kbd>⎋</kbd> dismiss
        </span>
      )}
      {showRemove && (
        <span>
          <kbd>⌫</kbd> remove
        </span>
      )}
      {showNext && (
        <span>
          <kbd>⇥</kbd> next
        </span>
      )}
    </div>
  );
}
